import { colors } from '@/theme';

export const loginContainerStyle = {
  padding: {
    xs: '10px 0px 0px 0px',
    sm: '40px 0px 0px 0px',
    md: '80px 0px 0px 0px',
    lg: '80px 0px 0px 60px',
  },
  width: {
    xs: '90%',
    md: '80%',
    lg: 'calc(100% * 5 / var(--Grid-columns))',
  },
  margin: {
    xs: '0 auto',
    lg: 0,
  },
  zIndex: 2,
};

export const loginContainerSize = { xs: 12, sm: 12, md: 12, lg: 5, xl: 5 };

export const loginButtonStyle = {
  mt: {
    xs: 2,
    md: 3,
    lg: 3.5,
  },
  padding: 1,
  color: colors.white,
  backgroundColor: colors.purplePrimary,
  ':hover': {
    backgroundColor: colors.purplePrimary,
  },
  textTransform: 'initial',
  fontSize: '1rem',
};
